import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pages } from 'components/pages';
import { PermissionGuard } from 'components/permissions';
import Roles from 'components/role';

const RolesRoute: React.FC = () =>
{

  return (
    <PermissionGuard
      permission={Roles.Const.permissions.VIEW}
      fallback={<Pages.Page403 />}
    >
      <Routes>
        <Route path="/" element={<Pages.Roles />} />
        <Route path="/page/:pageNum" element={<Pages.Roles />} />
        <Route path="/page" element={<Pages.Roles />} />
        <Route path="/:id/*" element={<Pages.Role />} />
        <Route path="/create/*" element={<Pages.Role />} />
      </Routes>
    </PermissionGuard>
  );
};


export default RolesRoute;
